var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeason1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5556 0.191545C10.1632 0.509837 0 16.2075 0 16.4954C0 16.639 0.125234 16.8773 0.278234 17.025L0.556353 17.2937H4.0749C6.36389 17.2937 7.59333 17.3323 7.59333 17.4041C7.59333 17.4648 7.02395 19.7138 6.32797 22.4018C5.15553 26.9302 5.07461 27.31 5.22648 27.5712C5.45473 27.9641 5.93878 28.1138 6.31233 27.9072C6.69177 27.6972 17 11.8982 17 11.5266C17 11.382 16.8748 11.143 16.7218 10.9952L16.4436 10.7265H12.9251C10.6155 10.7265 9.40667 10.6883 9.40667 10.6152C9.40667 10.5539 9.96767 8.33832 10.6533 5.69161C11.339 3.0449 11.9 0.802407 11.9 0.708386C11.9 0.445478 11.3766 0 11.0677 0C10.9159 0 10.6855 0.0862497 10.5556 0.191545Z",
    fill: "#FFB60C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeason1);
export default __webpack_public_path__ + "static/media/season1.b14cda7b27c6a71c89ffe5aa4045ebe0.svg";
export { ForwardRef as ReactComponent };